<template>
  <div class="">
    <div
      class="item-type-document mb-4"
      v-for="(item, index) in typeDocuments"
      :key="index"
      @click.prevent="listDocuments(item?.type)"
    >
      <div
        class="circle-img"
        :style="{ background: `${item?.hasFiles ? '#1719DA' : '#828789'}` }"
      >
        <img
          src="@/assets/images/icons/icon-success-litigio.svg"
          alt=""
          v-if="item?.hasFiles"
        />
        <img
          src="@/assets/images/icons/icon-document-litigio.svg"
          alt=""
          v-else
        />
      </div>
      <span>{{ item?.name }}</span>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    typeDocuments: {
      type: Array,
      default: () => [],
    },
    processId: {
      type: Number,
      default: 0,
    }
  },
  methods: {
    listDocuments(typeDocument) {
      const me = this;
      me.$router.push({ name: 'Legal_list_documentation', params: {
        id: me.processId,
        type: typeDocument,
      }})
    }
  }
};
</script>

<style lang="css" scoped>
/* #1719DA */
.item-type-document {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 18px;
  cursor: pointer;
  width: 50%;
}
.item-type-document .circle-img {
  width: 30px;
  height: 30px;
  background: #828789;
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
